import { render, staticRenderFns } from "./StudySetCard.vue?vue&type=template&id=5c3a866c&"
import script from "./StudySetCard.vue?vue&type=script&lang=js&"
export * from "./StudySetCard.vue?vue&type=script&lang=js&"
import style0 from "./StudySetCard.vue?vue&type=style&index=0&id=5c3a866c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports